<template>
  <div class="brandSelect">
    <div class="selectBox">
      <span>ブランド選択</span>
      <v-autocomplete
        v-model="parentBrandId"
        :items="parentBrands"
        label="ブランドを選択または、検索して下さい。"
        no-data-text="ブランドがありません。"
        class="UXautocomplete UXselect medium"
        :menu-props="{contentClass:'UXautoMenu'}"
        item-text="name"
        item-value="id"
        outline
        solo
        hide-details
      ></v-autocomplete>
      <span v-if="mappingBrands.length" class="brandGuideTxt">
         該当するブランドにマッピングされたブランドがあります。
      </span>
    </div>
    <div class="mappingBrands" v-if="mappingBrands.length">
      <span v-for="brandItem in mappingBrands"
        :key="brandItem.id"
        @click="changeCurrentParentBrandId(brandItem.id)"
        class="cursor">
        {{ brandItem.name }}
      </span>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
export default {
  name: 'BrandSelect',
  data () {
    return {
      parentBrands: [],
      mappingBrands: []
    }
  },
  computed: {
    ...mapGetters([
      'currentParentBrandId'
    ]),
    parentBrandId: {
      get () {
        return this.currentParentBrandId
      },
      set (val) {
        return this.changeCurrentParentBrandId(val)
      }
    }
  },
  watch: {
    parentBrandId (brandId) {
      if (brandId) {
        this.findMappingBrand(brandId)
      }
    }
  },
  created () {
    this.searchAllBrands()
  },
  mounted () {
    if (this.parentBrandId) {
      this.findMappingBrand(this.parentBrandId)
    }
  },
  methods: {
    ...mapMutations([
      'changeCurrentParentBrandId'
    ]),
    searchAllBrands () {
      this.axios.get('/api/brand/listAll')
        .then(result => {
          if (result.data.code === 0) {
            const { data } = result.data
            this.parentBrands = data.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
          } else {
            this.$alertMsg(result.data.message)
          }
        })
    },
    findMappingBrand (brandId) {
      this.axios.get(`/api/brand/${brandId}/findMappingBrandNames`)
        .then(result => {
          if (result.data.code === 0) {
            this.mappingBrands = result.data.data
          }
        }).catch(errorMsg => console.log(errorMsg))
    }
  }
}
</script>

<style scoped lang="scss">
.brandSelect {
  display: flex;
  flex-direction: column;
  .selectBox {
    display: flex;
    span {
      font-size: 16px;
      font-weight: 700;
      color: #121212;
      display: flex;
      align-items: center;
    }
    .v-select {
      max-width: 400px;
      width: 400px;
      margin-left: 10px;
    }
    .brandGuideTxt {
      padding-left: 10px;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: $gray-7;
    }
  }
  .mappingBrands {
    display: inline-block;
    padding-top: 25px;
    margin-left: -8px;
    margin-bottom: -10px;
    span {
      display: inline-flex;
      background: #F0F5FF;
      border: 1px solid #B4CDFA;
      border-radius: 3px;
      padding: 5px;
      color: $gray-8;
      margin-left: 8px;
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/components/BrandSelect.vue